import React, { createContext, useContext, useState, ReactNode } from 'react';

interface GridContextType {
  showGrid: boolean;
  setShowGrid: (show: boolean) => void;
}

const GridContext = createContext<GridContextType | undefined>(undefined);

export const GridProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [showGrid, setShowGrid] = useState<boolean>(false); // Disabled by default

  return (
    <GridContext.Provider value={{ showGrid, setShowGrid }}>
      {children}
    </GridContext.Provider>
  );
};

export const useGrid = (): GridContextType => {
  const context = useContext(GridContext);
  if (context === undefined) {
    throw new Error('useGrid must be used within a GridProvider');
  }
  return context;
};
